import { createRoot } from 'react-dom/client'
import { App } from './app/App'
import { TonConnectUIProvider } from '@tonconnect/ui-react'
import { init } from './init'
import TelegramAnalytics from '@telegram-apps/analytics'
import { MANIFEST_URL } from './shared/constants'

const root = document.getElementById('root')
if (!root) throw new Error('Root element not found')

TelegramAnalytics.init({
  token: import.meta.env.VITE_ANALYTICS_TOKEN,
  appName: 'gamed',
})

init()

console.log(MANIFEST_URL)
createRoot(root).render(
  <TonConnectUIProvider manifestUrl={MANIFEST_URL}>
    <App />
  </TonConnectUIProvider>
)
